<section class="section-div">
  <div class="content-details">
    <div class="container-fluid">
      <div class="title-details">
        <div class="d-flex">
          <h4>
            <ion-icon name="calendar-outline"></ion-icon> Connect With Incubator
            List
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-md-5">
          <div>
            <div class="ml-auto">
              <mat-form-field appearance="standard" class="material-full-width">
                <mat-label>Search By Name / Startup Name</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input
                  matInput
                  (keyup)="applySearch($event)"
                  placeholder="Search By Name / StartupName"
                  #input
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <form action="" [formGroup]="formValue">
            <div class="row">
              <div class="col-lg-5">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Supports</mat-label>
                    <mat-select
                      formControlName="purpose"
                      (selectionChange)="onSelect($event.value)"
                    >
                      <mat-option
                        *ngFor="let option of Supports"
                        [value]="option"
                      >
                        {{ option }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-7">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Select Incubator</mat-label>

                    <mat-select
                      formControlName="incubator"
                      (selectionChange)="selectIncubator($event.value)"
                      placeholder="Search Incubator Name"
                    >
                      <mat-option [value]="0"> All</mat-option>
                      <mat-option
                        *ngFor="let list of incubatorListValue | async"
                        [value]="list.incubatorId"
                      >
                        {{ list.incubatorName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="mt-3 col-lg-1 col-md-1" *ngIf="noData == false">
          <div class="download-div">
            <button mat-raised-button color="accent" (click)="openModal()">
              Export <i class="far fa-file-excel"></i>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="noData == false">
        <div class="example-container mat-elevation-z8">
          <mat-table
            #table
            [dataSource]="dataSource"
            [class.isMobile]="isMobile"
          >
            <ng-container matColumnDef="index">
              <mat-header-cell *matHeaderCellDef class="max-width">
                #
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                class="max-width"
              >
                <span class="mobile-label">No :</span>
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef>Name </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Name :</span>
                <span>{{ element.name }}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="startupName">
              <mat-header-cell *matHeaderCellDef>Startup Name </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Startup Name :</span>
                <span>{{ element.startupName }}</span>
                <span *ngIf="!element.startupName" class="ml-2"> - </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Email :</span>
                <span style="word-break: break-all">{{ element.email }}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="phone">
              <mat-header-cell *matHeaderCellDef
                >Contact Number</mat-header-cell
              >
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Contact Number :</span>
                <span class="ml-2">{{ element.phone }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="purposes">
              <mat-header-cell *matHeaderCellDef>Supports</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Supports :</span>
                <span>{{ element.purposes }}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <mat-header-cell *matHeaderCellDef>Incubator</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Incubator :</span>
                <span>{{ element.incubatorName }}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="message">
              <mat-header-cell
                *matHeaderCellDef
                class="max-width2 justify-content-center"
                >Brief</mat-header-cell
              >
              <mat-cell *matCellDef="let element" class="max-width2">
                <span class="mobile-label">Brief :</span>
                <span class="eye-icon margin-lef" *ngIf="element.message">
                  <ion-icon
                    name="eye-outline"
                    (click)="viewDescrptionBtn(element.message, 'View Brief')"
                  ></ion-icon
                ></span>
                <span *ngIf="!element.message" class="ml-2"> - </span>
              </mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>

        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>No Records Found</h6>
      </div>
    </div>
  </div>
</section>
